/** IDs das operações de conta e ordem dos pedidos */
export enum OperacaoContaOrdemID {
    SEM_OPERACAO = 1,
    NORMAL = 2,
    INDUSTRIALIZACAO = 3
}

export namespace OperacaoContaOrdemID {
    /** Verifica se é sem operação de conta e ordem */
    export function isSemOperacao(id: number): boolean {
        return id == OperacaoContaOrdemID.SEM_OPERACAO;
    }

    /** Verifica se é a operação de conta e ordem Normal */
    export function isNormal(id: number): boolean {
        return id == OperacaoContaOrdemID.NORMAL;
    }


    /** Verifica se é a operação de conta e ordem para Industrialização */
    export function isIndustrializacao(id: number): boolean {
        return id == OperacaoContaOrdemID.INDUSTRIALIZACAO;
    }
}

/** Representa uma Operação de Conta e Ordem */
export interface OperacaoContaOrdem {
    id: OperacaoContaOrdemID;
    nome: string;
    descricao: string;
}

export namespace OperacaoContaOrdem {
    /** Sem Operação de Conta e Ordem */
    export const SEM_OPERACAO: OperacaoContaOrdem = {
        id: OperacaoContaOrdemID.SEM_OPERACAO,
        nome: 'Sem Operação',
        descricao: 'Sem operação de conta e ordem'
    };

    /** Operação de Conta e Ordem Normal */
    export const NORMAL: OperacaoContaOrdem = {
        id: OperacaoContaOrdemID.NORMAL,
        nome: 'Normal',
        descricao: 'Operação de conta e ordem normal'
    };

    /** Operação de Conta e Ordem para Industrialização */
    export const INDUSTRIALIZACAO: OperacaoContaOrdem = {
        id: OperacaoContaOrdemID.INDUSTRIALIZACAO,
        nome: 'Industrialização',
        descricao: 'Operação de conta e ordem para industrialização'
    };

    /** Retorna todas as operações de conta e ordem */
    export function getAll(): OperacaoContaOrdem[] {
        return [
            SEM_OPERACAO,
            NORMAL,
            INDUSTRIALIZACAO
        ];
    }

    /** Obtém a operação de conta e ordem pelo id */
    export function getById(id: number): OperacaoContaOrdem | undefined {
        return getAll().find(operacao => operacao.id === id);
    }
}
